import axios from "axios";
import { headersTokenConfig } from "../config/HeaderToken";

class SalaryCalculation {
  sync (payload) {
    const url = process.env.REACT_APP_API_URL_V2 + `/worker/salary/calculation/sync`
    return axios.post(url, payload, headersTokenConfig)
  }

  salaryCalculation(page, limit, search, startDate, endDate, sort_by, sort_type, source_project, sesi) {
    const params = {
      start_date: startDate,
      end_date: endDate,
      page: page,
      limit: limit,
    };

    if (sort_by) {
      params.sort_by = sort_by;
    }

    if (sort_type) {
      params.sort_type = sort_type;
    }

    if (source_project) {
      params.source_project = source_project;
    }

    if (sesi !== null && sesi !== undefined) {
      params.sesi = sesi;
    }

    let baseUrl = process.env.REACT_APP_API_URL_V2;
    let endPoint = `/worker/salary/calculation?` + new URLSearchParams(params).toString();

    if (search) {
      baseUrl = process.env.REACT_APP_API_URL_V2;
      endPoint += `&search=${search}`;
    }

    const url = `${baseUrl}${endPoint}`;
    return axios.get(url, headersTokenConfig);
  }

  confirm(id) {
    const endPoint = `/upah-tukang/${id}/confirm`;
    const url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.put(url, null, headersTokenConfig);
  }

  edit(id, payload) {
    const endPoint = `/worker/salary/calculation/${id}/update`;
    const url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.put(url, payload, headersTokenConfig);
  }

  undo(id) {
    const endPoint = `/worker/salary/calculation/${id}/undo`;
    const url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.put(url, null, headersTokenConfig);
  }

  delete(id) {
    const endPoint = `/worker/salary/calculation/${id}/remove`;
    const url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.put(url, null, headersTokenConfig);
  }

  addWorker(payload) {
    const endPoint = `/worker/salary/calculation/add`;
    const url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.post(url, payload, headersTokenConfig);
  }

  posting(start, end) {
    const endPoint = `/worker/salary/calculation/posting`;
    const payload = { start_date: start, end_date: end };
    const url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.post(url, payload, headersTokenConfig);
  }

  refund(payload) {
    const endPoint = `/upah-tukang/refund-contractor`;
    const url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.post(url, payload, headersTokenConfig);
  }
}

export default new SalaryCalculation();
